import axios from '../axiosInstance';

export type InsuranceClaimsGetParams = {
  rok?: number;
  mesic?: number;
  pojistovna?: string;
};

export type InsuranceClaimsExportParams = InsuranceClaimsGetParams & {
  delivery?: 'download' | 'save';
};

const ENDPOINT = '/v1/insurance-claims/';

export const InsuranceClaimsApi = () => ({
  getPreview: (params?: InsuranceClaimsGetParams) =>
    axios.get(ENDPOINT, { params }),

  exportFile: (params?: InsuranceClaimsExportParams) =>
    axios.get(`${ENDPOINT}export`, { params, responseType: 'blob' })
});
